import { Component, HostListener, ElementRef, Input, OnInit, ApplicationRef, ViewContainerRef, ViewChild } from '@angular/core';
import { UserHandling } from '../../shared/user-handling';
import { ErrorObject } from '../../errorhandler/gpiserror-object';
import { User } from '../../shared/user.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { ErrorHandlerService } from '../../errorhandler/gpiserror-handler.service';
import { AppConfig } from '../../config/app.config';
import { Http, RequestOptions, XHRBackend } from '@angular/http';
import { CustomToastOption } from '../../shared/custom-toast-options';
import { ErrorTypeEnum } from '../../shared/enums.model';
import { GlobalHttpHandler } from '../../global-http-handler';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  host: {
    '[class.sidebar-collapsed]': 'sidebarCollapsed',
    '[class.sticky-header]': '!sidebarCollapsed',
    '[class.sidebar-open]': '!sidebarCollapsed'
},
providers: [
  { provide: Http, useClass: GlobalHttpHandler, deps: [XHRBackend, RequestOptions] }
],
  styleUrls: ['./home.component.css']
})
export class HomeComponent  {

  userHandl: UserHandling = null;
    currentSystem: string = this.config.get('currentsystem');
    errorObj: ErrorObject = null;
    pageHeaderText: string = 'Dashboard';
    user: User;
    sidebarCollapsed: boolean = false;
    errorTimer: any;
    showSpinner: boolean = true;
    showWamLogin = false;

    @ViewChild("popUser") public popUser: NgbPopover;

    constructor(private toastr: ToastsManager,
        private vcr: ViewContainerRef,
        private errHandler: ErrorHandlerService,
        private config: AppConfig,
        private elRef: ElementRef,
        private appRef: ApplicationRef,
        public globalHttpHandler: Http) {

        this.errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
        this.toastr.setRootViewContainerRef(vcr);

       this.loadUser();

        // (<GlobalHttpHandler>this.globalHttpHandler).showWamLogin.subscribe(data =>
        //     this.showWamLogin = data
        // );
    }

    custOption: any = new CustomToastOption().getCustomOptions("customErrMsgClass", "customTitleClass");
    errOption: any = new CustomToastOption().getErrorOptions();
    warnOption: any = new CustomToastOption().getWarningOptions();
    successOption: any = new CustomToastOption().getSuccessOptions();
    infoOption: any = new CustomToastOption().getInfoOptions();

    onError(error: ErrorObject) {
        this.errorObj = this.errHandler.getError();
        if (this.errorObj != null) {
            if (this.errorObj.errType == ErrorTypeEnum.Error)
                this.toastr.error(this.errorObj.errorText, this.errorObj.originator, this.errOption);
            else if (this.errorObj.errType == ErrorTypeEnum.Info)
                this.toastr.info(this.errorObj.errorText, this.errorObj.originator, this.infoOption);
            else if (this.errorObj.errType == ErrorTypeEnum.Success)
                this.toastr.success(this.errorObj.errorText, this.errorObj.originator, this.successOption);
            else if (this.errorObj.errType == ErrorTypeEnum.Warning)
                this.toastr.warning(this.errorObj.errorText, this.errorObj.originator, this.warnOption);
            else if (this.errorObj.errType == ErrorTypeEnum.Custom)
                this.toastr.custom(this.errorObj.errorText, this.errorObj.originator, this.custOption
                    , );
        }
    }

    resetError() {
        this.errorObj = null;
        clearTimeout(this.errorTimer);
        this.errHandler.emitErrorObject(null);
    }

    sidebarToggle() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.sidebarCollapsed = window.innerWidth < 1024;
    }

    onMenuClicked(menuText: string): void {
        this.pageHeaderText = menuText;
    }

    loadUser(): void {
       // this.auth.login().then(() =>
        {
            let userData = localStorage.getItem("userData");
            if (userData) {
                this.user = new User().deserialize(userData);
                this.userHandl = new UserHandling();
                if (!this.userHandl.IsPackagingAdmin
                    && !this.userHandl.IsPackagingEngineer
                    && !this.userHandl.IsPartSupplierUser) {
                    this.pageHeaderText = "Welcome";
                }
            }

            this.showSpinner = false;

        };
    }

    emulateRole(role: string) {
        if (role == "APPLICATIONDEFUALT") {
            let resetData: any = JSON.parse(localStorage.getItem("emulateResetUserData"));
            localStorage.setItem("userData", localStorage.getItem("emulateResetUserData"));
            localStorage.setItem("userRoles", resetData.Roles);
            return;
        }

        let roles: string[] = [];
        let data: any = JSON.parse(localStorage.getItem("userData"));

        roles.push(role);
        localStorage.removeItem("userRoles");
        localStorage.removeItem("userData");
        data.Roles = roles;
        data.SupplierNumber = "784001";
        data.ExtendedSupplierNumber = "";
        localStorage.setItem("userData", JSON.stringify(data))
        localStorage.setItem("userRoles", roles.join(','));
    }

    showEmulateRoleList() {
        //return ( this.currentSystem == 'Development' || this.currentSystem == 'System Test' ) && !this.showSpinner;
        return this.currentSystem != '' && !this.showSpinner;
    }

    isPopUserOpen() {
        try {
            return this.popUser.isOpen();
        } catch (error) {
            return false;
        }
    }

    closePopUser() {
        this.popUser.close();
    }

    logout() {
      window.location.href = `${this.config.get('apiUrl')}AccessControl/PerformSSOLogout?userName=${localStorage.getItem('CURRENT_USER')}`;
      localStorage.clear();
    }



}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/home/home/home.component.ts